import React from "react";
import { Box, Button, TextField, Autocomplete } from "@mui/material";
import { FilterSensors, DateRangePicker } from "../../../../components";

const inputSx = { "& .MuiOutlinedInput-root": { height: 44 } };

const Filter = ({ filter, contractId, onChange, onReset, onSearch }) => {
  const handleDateRangeChange = ({ start, end }) => {
    onChange({ ...filter, page: 1, datetime_start: start, datetime_end: end });
  };
  const handleTextFieldChange = (e) => {
    onChange({ ...filter, page: 1, [e.target.name]: e.target.value });
  };

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <DateRangePicker label="Дата и время" className="--floating-label" showTimePicker endDate={filter.datetime_end} startDate={filter.datetime_start} onChange={handleDateRangeChange} sx={inputSx} />
      </Box>
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <TextField value={filter.license_plate} onChange={handleTextFieldChange} label="Госномер" variant="outlined" name="license_plate" className="--floating-label" fullWidth sx={inputSx} />
      </Box>
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <TypeAutocomplete value={filter.event_type} filter={filter} onChange={onChange} />
      </Box>
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <TextField value={filter.sensor_location} onChange={handleTextFieldChange} label="Местоположение" variant="outlined" name="sensor_location" className="--floating-label" fullWidth sx={inputSx} />
      </Box>
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <FilterSensors value={filter.sensor_ids} contractId={contractId} name="sensor_ids" onChange={handleTextFieldChange} />
      </Box>
      <Button color="secondary" variant="contained" onClick={onReset} sx={{ flexShrink: 0, height: 44, fontSize: 14, fontWeight: 500, textTransform: "none", whiteSpace: "nowrap" }}>Сбросить</Button>
      <Button variant="contained" onClick={onSearch} sx={{ flexShrink: 0, height: 44, fontSize: 14, fontWeight: 500, textTransform: "none", whiteSpace: "nowrap" }}>Применить</Button>
    </Box>
  )
}

const TypeAutocomplete = ({ value, filter, onChange }) => {
  const options = [
    { label: 'Нарушение ПДД', value: 'violation' },
    { label: 'Без нарушений', value: 'no_violation' },
    { label: 'Для распознавания ГРЗ', value: 'apvgk' },
  ];
  const selectedOptions = (value || []).map((v) => options.find((t) => t.value === v)).filter(Boolean);
  const handleChange = (event, newValue) => {
    onChange({ ...filter, page: 1, event_type: (newValue || []).map((t) => t.value) });
  };

  return (
    <Autocomplete
      multiple
      value={selectedOptions}
      options={options}
      fullWidth
      getOptionLabel={(v) => (typeof v === 'string' ? options.find((t) => t.value === v)?.label || '' : v?.label)}
      isOptionEqualToValue={(option, val) => option.value === val.value}
      renderInput={(params) => (
        <TextField {...params} label="Событие" className="--floating-label" sx={{ "& .MuiOutlinedInput-root": { minHeight: 44, display: "flex", alignItems: "center", flexWrap: "nowrap", "& input": { padding: "0 !important" } } }} />
      )}
      onChange={handleChange}
    />
  )
};

export default Filter;
